import SideBar from './base';
import Drawer from './drawer';
import Sider from './sider';

export default Object.assign(SideBar, { Drawer, Sider });
